module.exports = __webpack_public_path__ + "static/logo-2a5dbfd75db46af1739f714108080555.png";